import React, { MouseEventHandler, ReactNode } from "react"
import styled from "styled-components"
import { Paragraph, ParagraphTextArea } from "../../screens/Dashboard/styles"

const StyledTable = styled.table`
  border-collapse: collapse;
  max-width: 1080px;
  width: 100%;
  margin: 30px auto 0;
  font-size: 0.8em;
`

const StyledHeader = styled.th`
  background-color: #e5e5e5;
  text-align: left;
  padding: 1em;
`

const StyledTableData = styled.td`
  padding: 1em;
`

const StyledLink = styled.a`
  color: #007bff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

const StyledRow = styled.tr`
  border-bottom: 1px solid #e5e5e5;

  ${(props) =>
    props.onClick
      ? `
    &:hover {
      background-color: #e5e5e588;
      cursor: pointer;
    }
  `
      : ""}
`

export const Row = ({
  onClick,
  values,
}: {
  onClick?: MouseEventHandler
  values: string[]
}) => {
  // Check for the valid URL
  const isValidUrl = (description: string) => {
    const validUrl = description.match(/https?:\/\/[^\s]+/)
    if (validUrl) {
      try {
        new URL(validUrl[0])
        return true
      } catch (error) {
        return false
      }
    }

    return false
  }

  // Function to make text bold, Italic and Underline
  const formatText = (text: string) => {
    const bold = /\*\*(.*?)\*\*/g
    const italic = /\*(.*?)\*/g
    const underline = /__(.*?)__/g

    let formattedText = text.replace(
      bold,
      (match, p1) => `<strong>${p1}</strong>`
    )

    formattedText = formattedText.replace(
      italic,
      (match, p1) => `<em>${p1}</em>`
    )

    formattedText = formattedText.replace(
      underline,
      (match, p1) => `<u>${p1}</u>`
    )

    return formattedText
  }

  return (
    <StyledRow onClick={onClick}>
      {values.map((value, index) => (
        <StyledTableData key={index}>
          {typeof value === "string" ? (
            value.split("\n").map((line, index) => (
              <ParagraphTextArea key={index}>
                {isValidUrl(line) ? (
                  <StyledLink
                    href={line}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {line}
                  </StyledLink>
                ) : (
                  // line
                  <span
                    dangerouslySetInnerHTML={{ __html: formatText(line) }}
                  />
                )}
              </ParagraphTextArea>
            ))
          ) : (
            <Paragraph>{value}</Paragraph>
          )}
        </StyledTableData>
      ))}
    </StyledRow>
  )
}

export const NoResultsRow = ({
  colSpan,
  message,
}: {
  colSpan: number
  message: string
}) => {
  return (
    <StyledRow>
      <StyledTableData colSpan={colSpan}>{message}</StyledTableData>
    </StyledRow>
  )
}
const Table = ({
  columnNames,
  children,
  isEmpty,
  noResultMessage = "No results found",
}: {
  columnNames: string[]

  children?: ReactNode
  isEmpty: boolean

  noResultMessage?: string
}) => {
  return (
    <StyledTable>
      <thead>
        <StyledRow>
          {columnNames.map((column) => (
            <StyledHeader key={column}>{column}</StyledHeader>
          ))}
        </StyledRow>
      </thead>
      <tbody>
        {isEmpty ? (
          <NoResultsRow
            colSpan={columnNames.length}
            message={noResultMessage}
          />
        ) : (
          children
        )}
      </tbody>
    </StyledTable>
  )
}

export default Table
